import { headerBgGradient2 } from "./HeaderBgStore";

export const updateHeaderBgGradient2 = (value) => headerBgGradient2.update(oldValue => value);
